import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ANIMAL_TYPES, COLORS } from '../lib/constants'

interface Props {
  open: boolean
  onClose: () => void
}

export function ReportLostModal({ open, onClose }: Props) {
  const { t } = useTranslation()
  const [type, setType] = useState('dog')
  const [color1, setColor1] = useState('black')
  const [breedOther, setBreedOther] = useState('')
  const [contact, setContact] = useState('')

  if (!open) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="lost-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="lost-title">{t('forms.reportLostTitle')}</h2>
        <form
          className="form-grid"
          onSubmit={(e) => {
            e.preventDefault()
            onClose()
          }}
        >
          <div className="field">
            <label htmlFor="lost-type">{t('fields.type')}</label>
            <select id="lost-type" value={type} onChange={(e) => setType(e.target.value)}>
              {ANIMAL_TYPES.map((key) => (
                <option key={key} value={key}>
                  {t(`types.${key}`)}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label htmlFor="lost-color1">{t('fields.color1')}</label>
            <select id="lost-color1" value={color1} onChange={(e) => setColor1(e.target.value)}>
              {COLORS.map((key) => (
                <option key={key} value={key}>
                  {t(`colors.${key}`)}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label htmlFor="breed-other">
              {t('fields.breed')} ({t('fields.other')})
            </label>
            <input
              id="breed-other"
              value={breedOther}
              onChange={(e) => setBreedOther(e.target.value)}
              placeholder={t('forms.breedOtherHint')}
            />
          </div>
          <div className="field">
            <label htmlFor="contact">{t('fields.contact')}</label>
            <textarea
              id="contact"
              rows={3}
              value={contact}
              onChange={(e) => setContact(e.target.value)}
              required
            />
          </div>
          <div className="form-actions">
            <button type="button" className="btn" onClick={onClose}>
              {t('actions.cancel')}
            </button>
            <button type="submit" className="btn btn-primary">
              {t('actions.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
